'use client';

import useClickOutside from '@/hooks/useClickOutside';
import { useLocale } from 'next-intl';
import { usePathname, useRouter } from 'next/navigation';
import { useState } from 'react';
import { GrLanguage } from 'react-icons/gr';

const languages = [
  { value: 'ar', label: 'العربية' },
  { value: 'en', label: 'English' },
];

type Props = {
  className?: string;
};

export const SwitchLanguage: React.FC<Props> = ({ className }) => {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useClickOutside<HTMLDivElement>(() => setIsOpen(false));

  const currentLanguage =
    languages.find(lang => lang.value === locale) || languages[0];

  const handleLanguageChange = (newLocale: string) => {
    const segments = pathname.split('/');
    segments[1] = newLocale;
    const newPathname = '/' + segments.filter(Boolean).join('/');

    router.push(newPathname);
    setIsOpen(false);
  };

  return (
    <div
      ref={ref}
      className={`${className} relative flex gap-3 items-center`}
      onClick={() => setIsOpen(!isOpen)}
    >
      {isOpen && (
        <ul className="absolute top-14 z-50 rounded-lg bg-white p-5 text-black cardShadow before:absolute before:-top-2 before:h-5 before:w-5 before:rotate-45 before:rounded before:bg-white lg:top-10">
          {languages.map(({ label, value }) => (
            <li
              key={value}
              onClick={() => handleLanguageChange(value)}
              className="mb-2 cursor-pointer last:mb-0 hover:opacity-50"
            >
              {label}
            </li>
          ))}
        </ul>
      )}
      <div className="flex w-fit cursor-pointer items-center gap-2 font-semibold transition-all hover:opacity-80">
        {currentLanguage.label}
        <GrLanguage aria-label='language' className="w-4" />
      </div>
    </div>
  );
};
